import axios from '@/store/config';
import { find } from 'lodash'

export default {
  // state
  state : {
    queuePoints:null,
    queuePointsStudent:null,
    queuePointsParking:null,
    queuePointsPremise:null,
    queuePointsCultivation:null,
    offerCount: 0,
    interestCount: {},
    subscriptionCount: {},
    siteinfo: {}
  },
  getters : {
    queuePoints: state => state.queuePoints,
    queuePointsStudent: state => state.queuePointsStudent,
    queuePointsParking: state => state.queuePointsParking,
    queuePointsPremise: state => state.queuePointsPremise,
    queuePointsCultivation: state => state.queuePointsCultivation,
    interestCount : state => state.interestCount,
    subscriptionCount: state => state.subscriptionCount,
    offerCount: state => state.offerCount,
    siteinfo: state => state.siteinfo
  },
  actions : {

    /**
     * Hämtar dashboard  från API och sätter allt i state.
     */
    getDashboard({ state, dispatch, commit }) {

      return axios.get('/Applicants/me/dashboard').then((response) => {
        commit('setSiteInfo', response.data.siteinfo);
        commit('setOfferCount', response.data.offerCount);

        /**
         * Skickar in intresseanmälningar i det format som dashboard.vue använder dem
         */
        commit('setInterestCount', { apartments : response.data.noteOfInterestApartmentCount, parkings : response.data.noteOfInterestParkingCount, premises : response.data.noteOfInterestPremisesCount });

        /**
         * Skickar in bevakningar i det format som dashboard.vue använder dem
         */
        commit('setSubscriptionCount', { apartments : response.data.activeApartmentSubscriptionCount, parkings : response.data.activeParkingSubscriptionCount, premises : response.data.activePremisesSubscriptionCount });


      }).catch((error) => {
          if (axios.isCancel(error) || error.code === 'ECONNABORTED') {
            console.warn('Dashboard request aborted');
            return;
          }
          console.error('Dashboard request failed:', error);
          throw error;
        });

    },

    getQueuePoints({ state, dispatch, commit }, contactCode) {
      if (!contactCode) contactCode = "me";

      return axios.get('/Applicants/' + contactCode + '/queuePointSummary').then((response) => {
        if(response.data) {
          let apartmentQueue = find(response.data, { WaitingListTypeCaption: "Torget, lgh" });
          let studentQueue = find(response.data, { WaitingListTypeCaption: "Torget, student" });
          let parkingQueue = find(response.data, { WaitingListTypeCaption: "Torget, bil" });
          let parkingQueueAlt = find(response.data, { WaitingListTypeCaption: "Torget, fordonsplats" });
          let premiseQueue = find(response.data, { WaitingListTypeCaption: "Torget, förråd" });
          let cultivationQueue = find(response.data, { WaitingListTypeCaption: "Torget, odlingslott" });
          if(apartmentQueue) commit('setQueuePointsApartment', apartmentQueue.QueuePoints);
          if(studentQueue) commit('setQueuePointsStudent', studentQueue.QueuePoints);
          if(parkingQueue) commit('setQueuePointsParking', parkingQueue.QueuePoints);
          else if(parkingQueueAlt) commit('setQueuePointsParking', parkingQueueAlt.QueuePoints);
          if(premiseQueue) commit('setQueuePointsPremise', premiseQueue.QueuePoints);
          if(cultivationQueue) commit('setQueuePointsCultivation', cultivationQueue.QueuePoints);
        }
      })

    },

  },
  mutations : {
    setQueuePointsApartment(state, queuePoints){
      state.queuePoints = queuePoints;
    },

    setQueuePointsStudent(state, queuePoints){
      state.queuePointsStudent = queuePoints;
    },

    setQueuePointsParking(state, queuePoints){
      state.queuePointsParking = queuePoints;
    },

    setQueuePointsPremise(state, queuePoints){
      state.queuePointsPremise = queuePoints;
    },

    setQueuePointsCultivation(state, queuePoints){
      state.queuePointsCultivation = queuePoints;
    },

    setInterestCount(state, interestCount){
      state.interestCount = interestCount;
    },

    setSubscriptionCount(state, subscriptionCount){
      state.subscriptionCount = subscriptionCount;
    },

    setOfferCount(state, nr){
      state.offerCount = nr;
    },
    setSiteInfo(state, info){
      state.siteinfo = info;
    }
  }
}
